import { Reveal } from "@/components/Reveal";

export const SectionHeading = ({ chapter, eyebrow, title, copy, dark = false, align = "left" }) => (
  <Reveal className={align === "center" ? "text-center" : ""}>
    <div className={`flex items-center gap-4 ${align === "center" ? "justify-center" : ""}`}>
      {chapter && (
        <span
          className={`font-display text-xs font-bold tracking-[0.3em] ${
            dark ? "text-gold-400" : "text-gold-600"
          }`}
          data-testid={`chapter-${chapter}`}
        >
          {chapter}
        </span>
      )}
      <span className="gold-rule" aria-hidden="true" />
      {eyebrow && <span className="eyebrow">{eyebrow}</span>}
    </div>
    <h2
      className={`mt-5 max-w-3xl text-4xl font-extrabold leading-[1.05] tracking-tight sm:text-5xl ${
        dark ? "text-white" : "text-navy-900"
      } ${align === "center" ? "mx-auto" : ""}`}
    >
      {title}
    </h2>
    {copy && (
      <p
        className={`mt-6 max-w-2xl text-base leading-relaxed sm:text-lg ${
          dark ? "text-white/65" : "text-muted-foreground"
        } ${align === "center" ? "mx-auto" : ""}`}
      >
        {copy}
      </p>
    )}
  </Reveal>
);
